<div class="content">
  <router-outlet name="action-panel-secondary"></router-outlet>
  <router-outlet name="action-panel"></router-outlet>
</div>
